export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-selection/src/selection/sparse.js
// module id = ../../../../d3-selection/src/selection/sparse.js
// module chunks = 3